import { Injectable } from '@angular/core';
import { AppConstants } from '@app/registered-user/core/constants';
import Helper from '../utils/Helper';

@Injectable({
  providedIn: 'root'
})
export class SessionSecurityService {
  constructor() {}

  public setObjectLocalStorage<T>(value: T, key: string) {
    if (value) {
      let setData = JSON.stringify(value);
      localStorage.setItem(key, this.evolve(this.evolve(setData)));
    } else {
      localStorage.removeItem(key);
    }
  }

  public getObjectLocalStorage<T>(key: string): T {
    let setData = localStorage.getItem(key);
    if (setData && !Helper.isNullOrEmpty(setData)) {
      setData = this.devolve(this.devolve(setData));
      return JSON.parse(setData) as T;
    }
    return null;
  }

  public deleteObjectLocalStorage(key: string) {
    localStorage.removeItem(key);
  }

  public setObject<T>(value: T, key: string) {
    if (value) {
      let setData = JSON.stringify(value);
      sessionStorage.setItem(key, this.evolve(this.evolve(setData)));
    } else {
      sessionStorage.removeItem(key);
    }
  }

  public getObject<T>(key: string): T {
    let setData = sessionStorage.getItem(key);
    if (setData && !Helper.isNullOrEmpty(setData)) {
      setData = this.devolve(this.devolve(setData));
      return JSON.parse(setData) as T;
    }
    return null;
  }

  protected evolve(value: string): string {
    if (value && value !== '') {
      return AppConstants.MUTATION + btoa(encodeURIComponent(value));
    }
    return null;
  }

  protected devolve(value: string): string {
    if (value && value !== '') {
      value = decodeURIComponent(atob(value.replace(AppConstants.MUTATION, '')));
    }
    return value;
  }
}
